import { inject, Injectable } from '@angular/core';
import { IirdsContainer } from '@enduradocs/iirds';
import { ArchiveSelectionStrategy } from '../../shared/archive-selection/archive-selection.strategy';
import { FileProcessorService } from '../../shared/services/file-processor.service';
import { iirdsStore } from '../../shared/stores/iirds.store';

/**
 * Portal's archive-selection strategy: unlike the viewer (single archive), the
 * portal builds its content from the *full* set of selected archives. It
 * aggregates every selected {@link IirdsContainer}'s iiRDS elements into one
 * browsable/searchable container via `iirdsStore.mergeContainers(...)`, picks a
 * valid language across the merged set, and navigates to the content view.
 * Registered via `provideArchiveSelectionStrategy(PortalArchiveSelectionStrategy)`
 * in `app.config.ts`.
 */
@Injectable({ providedIn: 'root' })
export class PortalArchiveSelectionStrategy
  implements ArchiveSelectionStrategy
{
  private iirds = inject(iirdsStore);
  private fileProcessor = inject(FileProcessorService);

  async select(containers: IirdsContainer[]): Promise<void> {
    if (!containers.length) {
      return;
    }
    this.iirds.mergeContainers(containers);
    this.fileProcessor.pickInitialLanguage(this.iirds.container());
    await this.fileProcessor.navigateToViewer();
  }
}
